<template>
	<v-container fluid class="grey lighten-3" grid-list-sm>
		<v-row>
			<v-col class="font-weight-black grey text-xs-center black--text py-1">
				<h3>نرم افزار های ارتباطی</h3>
			</v-col>
		</v-row>
		<v-row class="justify-center">
			<v-col cols="12" sm="6" md="3" pa-2 v-for="(item, idx) in items" :key="idx">
				<v-hover>
					<v-card height="100%" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" shaped>
						<v-card-title class="font-weight-black black--text justify-center">{{ item.text
							}}</v-card-title>

						<v-responsive>
							<v-img :src="item.image" contain height="100px"></v-img>
						</v-responsive>

						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn text color="grey darken-2" class="font-weight-thin black--text text-xs-center mb-0"
								:href="item.link" target="_blank">دانلود</v-btn>
						</v-card-actions>
					</v-card>
				</v-hover>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: "SupportTools",
	computed: {
		items() {
			const linksData = this.$store.state.filesLinks;
			let links = {}
			// links = {
			// 	anydesk: {
			// 		image: require("@/assets/img/Downloads/anydesk.jpg"),
			// 		text: "نرم افزار AnyDesk",
			// 		link: "",
			// 	},
			// 	alpemix: {
			// 		image: require("@/assets/img/Downloads/alpemix1.png"),
			// 		text: "نرم افزار Alpemix",
			// 		link: "",
			// 	},
			// };
			// for (let index = 0; index < linksData.length; index++) {
			// 	const element = linksData[index];
			// 	if (element.Name.toLowerCase() === "anydesk") {
			// 		links.anydesk.link = element.Link;
			// 	} else if (element.Name.toLowerCase() === "alpemix") {
			// 		links.alpemix.link = element.Link;
			// 	}
			// }
			for (let index = 0; index < linksData.length; index++) {
				const element = linksData[index];
				if (element.CategoryId == 5) {
					links[`index${index}`] = { text: element.Caption, link: element.Link, image: element.ImageLink }
				}
			}
			// console.log(linksData)
			return links;
		},
	},
};
</script>

<style>
.text-block {
	background-color: rgba(0, 0, 0, 0.644);
}
</style>
